import { listItemButtonClasses } from '@mui/material'
import { type ComponentsOverrides, type Theme } from '@mui/material/styles'

export const overridesListItemButton = (theme: Theme): ComponentsOverrides['MuiListItem'] => ({
  root: {
    [`&.${listItemButtonClasses.selected}`]: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
    [`&.${listItemButtonClasses.selected}:hover`]: {
      backgroundColor: theme.palette.primary.dark,
    },
    [`&.${listItemButtonClasses.focusVisible}`]: {
      backgroundColor: theme.customPalette.onElements.selected,
    },
    '&:hover': {
      backgroundColor: theme.customPalette.onElements.selected,
    },
  },
})
